<div (click)="closeRequested()" class="close"></div>
<div class="boxHeader">
    <img src="/assets/images/Configs.svg" />
    <h1>Add a New Config Type</h1>
</div>
